import React from 'react'
import { Modal } from 'react-bootstrap'
import DetailDoctor from '../DetailDoctor/index'
import DetailDoctorService from '../Service/DetailDoctorService'
import PasienService from '../Service/pasienService'
// import './detaildoctor.css'

export default class formInput extends React.Component {


    render() {
        const { image, changeHandler, saveHandler, Model, ShowModal, relasiList, bioList, treatList, locList, faskesList, faskes, List, ListCostumer_Relation, CancelHandler, errors, Mode, ListTreatment } = this.props

        return (

            <div class="mb-10">
                {/* {JSON.stringify(this.state.image)} */}
                <Modal show={ShowModal} onHide={CancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>{Mode} DOKTER</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div class="mb-12">

                            <div class="form-group row">
                                <div class="col-md-12" style={{ paddingTop: 30 }}>
                                    <div class="profile-info-left">
                                        <div class="col-md-3 float-left">
                                            <div class="profile-img">
                                                <a href="#"><img class="avatar" src={Model.image} alt="" /></a>
                                            </div>
                                        </div>

                                        <div class="row padding-top : 20px" style={{ marginLeft: 30 }}>
                                            <div class="col-md-12">
                                                
                                                        <tbody>
                                                            <h3 class="text">{Model.nama_dokter}</h3>
                                                            <small class="text">{Model.spesialisasi}</small>
                                                            <div class="text">{parseInt(Model.Tyear) - parseInt(Model.Lyear)} tahun pengalaman</div>
                                                        </tbody>
                                                   
                                            </div>

                                        </div>
                                    </div>

                                    <br></br>
                                    <label for="location_level_name" class="form-label lebar formInput">Konsultasi untuk*</label>
                                    <div class="lebar">
                                        <select class="form-control fontFormInput" aria-label="Disabled select example" disabled >
                                            <option selected hidden>{Model.nama_pasien}, {Model.hubungan}</option>

                                        </select>
                                    </div>

                                    <br></br>
                                    <label for="faskes_name" class="form-label lebar formInput">Faskes*</label>
                                    <div class="lebar">
                                        <select class="form-control fontFormInput" aria-label="Disabled select example" disabled>

                                            <option selected hidden>{Model.medical_facility}</option>

                                        </select>
                                    </div>

                                    <br></br>
                                    <label for="tanggal_datang" class="form-label lebar formInput">Waktu Kedatangan*</label>
                                    <div class="lebar">
                                        <input type="datetime-local" class="form-control"  value={Model.tanggal_datang} onChange={changeHandler("tanggal_datang")} />
                                        <span class="error">{errors["tanggal_datang"]}</span>
                                    </div>


                                    <br></br>
                                    <label for="location_level_name" class="form-label lebar formInput">Tindakan Medis*</label>
                                    <div class="lebar">
                                        <select class="form-control fontFormInput" onChange={changeHandler("doctor_office_treatment_id")}>
                                            <option selected hidden>{Model.treatment}</option>
                                            
                                            {
                                                ListTreatment.map(data => {
                                                    return (
                                                        <option value={data.doctor_office_treatment_id}>{data.treatment}</option>
                                                    )
                                                })
                                            }
                                            <span class="error">{errors["treatment"]}</span>
                                        </select>
                                        
                                    </div>

                                </div>

                                <br></br>

                            </div>
                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-primary" onClick={saveHandler}>Submit</button>
                        <button type="button" class="btn btn-primary" onClick={CancelHandler}>Cancel</button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}
